import Button from "../button/Button";
import { NoteIcon, CommentIcon, HelpIcon } from "../../utils/customIcons";
import { motion, AnimatePresence } from "framer-motion";
import { BiError } from "react-icons/bi";
import { Tooltip, TooltipTrigger, TooltipContent } from "../tooltip/Tooltip";
import { useAppDispatch, useAppSelector, useCustomTranslation, useIconSize } from "../../app/hooks";
import { selectCurrentBuilder, setActiveAction } from "../../app/features/builder/builderSlice";
import { selectCurrentProjectNote } from "../../app/features/project/projectSlice";
import { Actions } from "../../types/interfaces";
import { useHandleProjectState } from "@pages/project/useHandleProjectState";
import Spinner from "@components/spinner/Spinner";

export const NoteButton = () => {
	const dispatch = useAppDispatch();
	const note = useAppSelector(selectCurrentProjectNote);
	const { activeAction } = useAppSelector(selectCurrentBuilder);
	const { isLoading } = useHandleProjectState()
	const iconSize = useIconSize(16);

	const fill = note !== null ? "fill" : "";
	const handleShowNote = () => {
		if (activeAction !== Actions.Notes) {
			dispatch(setActiveAction(Actions.Notes))
		}
	};
	return (
		<Button onClick={handleShowNote}>
			{isLoading ? <Spinner size={20} isBlack /> : <NoteIcon fill={fill} size={iconSize} />}
		</Button>
	);
};

export const CommentButton = ({ active }: { active?: boolean }) => {
	const fill = active ? "fill" : "";
	return (
		<Button>
			<CommentIcon fill={fill} />
		</Button>
	);
};

export const HelpButton = ({ type }: { type: "info" | "video" }) => {
	const fill = type === "video" ? "fill" : "";
	return (
		<Button>
			<HelpIcon fill={fill} />
		</Button>
	);
};

export const ErrorWithTooltip = ({
	showError,
	errorLabel,
	style
}: {
	showError: boolean;
	errorLabel: string | undefined;
	style?: React.CSSProperties
}) => {
	const translatedLabel = useCustomTranslation(errorLabel);
	const iconSize = useIconSize(24);
	return (
		<AnimatePresence>
			{showError ? (
				<Tooltip placement="right-start">
					<TooltipTrigger>
						<motion.div
							className="form-row-icon clickable"
							initial={{ opacity: 0 }}
							animate={{ opacity: 1 }}
							exit={{ opacity: 0 }}
							whileHover={{ scale: 1.05 }}
							whileTap={{ scale: 0.95 }}
							style={style}
						>
							<BiError size={iconSize} color="var(--error)" />
						</motion.div>
					</TooltipTrigger>
					<TooltipContent className="error-tooltip unclickable">
						{translatedLabel ?? errorLabel}
					</TooltipContent>
				</Tooltip>
			) : null}
		</AnimatePresence>
	);
};
